<!-- eslint-disable @angular-eslint/template/i18n -->
<label class="custom-checkbox-container" [ngClass]="{'border-highlight': borderHighlight()}">
    @if (labelName()) {
        <span [class]="labelClass()">{{labelName()}}</span>
    }
    @if (!labelName() && ariaLabel()) {
        <span aria-hidden="true" class="sr-only">{{ariaLabel()}}</span>
    }
    
    <input 
        [tabindex]="inputTabIndex()"
        type="checkbox" 
        class="custom-checkbox-input" 
        [checked]="checked && !loading()"
        [attr.name]="name()"
        [attr.aria-label]="ariaLabel() || labelName()"
        [attr.aria-checked]="checked && !loading()"
        [disabled]="loading()"
        (change)="toggleCheckbox($event)"
        (keydown.space)="toggleCheckbox($event)"
        (keydown.enter)="toggleCheckbox($event)"
    >
    
    <div 
        class="custom-checkbox" 
        [class.checked]="checked && !loading()" 
        [class.loading]="loading()"
        aria-hidden="true"
    >
        <div class="checkbox-inner">
            @if(!checked && !loading()) {
                <div class="icon plus-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                        <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </div>
            }
            
            @if(loading()) {
                <div class="icon loading-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                        <circle class="spinner" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                    </svg>
                </div>
            }
            
            @if(checked && !loading()) {
                <div class="icon check-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                            <path d="M11.3296 0.998977L5.33112 8.33312" stroke="white" stroke-width="2" stroke-linecap="round"/>
                            <path d="M1.13672 4.53125L5.13672 8.53125" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </div>
            }
        </div>
    </div>
</label>